import { Pipe, PipeTransform } from 'angular-ts-decorators';

const upperCaseFirst = require('upper-case-first');

/**
 * Return provided string, with first letter uppercase
 * @param {string} input string to be modified
 * @return {string} modified string
 */
@Pipe({ name: 'upperCaseFirst' })
export class UpperCaseFirstPipe implements PipeTransform {
  constructor() {
    'ngInject';
  }

  public transform(input: string) {
    if (angular.isString(input)) {
      return upperCaseFirst(input);
    }

    return input;
  }
}
